import axios from '../utils/axios';
import API_URLS from '../constants/api-urls';
import { FEATURE_SWITCH_NAMES } from '../constants/feature-switch-names';

const featureAvailability = {
    get: (featureName: FEATURE_SWITCH_NAMES) => axios.get(`${API_URLS.FEATURE_SWITCH}/${featureName}`)
};

export default featureAvailability;
